
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const RoofMaterialsCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-brand-charcoal-gray to-brand-charcoal-gray/90">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-4 text-white">Ready to Choose Your Roofing Materials?</h2>
          <p className="text-xl text-gray-200 mb-8">
            Get expert guidance on selecting the perfect roofing materials for your project. 
            Our certified professionals will help you make the best choice for your budget and needs.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link to="/contact">
              <Button size="lg" className="bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold px-8">
                Get Free Consultation
              </Button>
            </Link>
            <Link to="/book-inspection">
              <Button size="lg" variant="outline" className="border-brand-trophy-gold text-brand-trophy-gold hover:bg-brand-trophy-gold/10 font-semibold px-8">
                Schedule Inspection
              </Button>
            </Link>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex flex-col items-center text-white">
              <Phone className="h-8 w-8 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Call Us</h3>
              <p className="text-sm text-gray-300">(252) 371-2266</p>
              <p className="text-xs text-gray-400">24/7 Emergency Service</p>
            </div>
            <div className="flex flex-col items-center text-white">
              <Mail className="h-8 w-8 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Email Us</h3>
              <p className="text-sm text-gray-300">info@carolinatrophyroofs.com</p>
              <p className="text-xs text-gray-400">Quick response guaranteed</p>
            </div>
            <div className="flex flex-col items-center text-white">
              <MapPin className="h-8 w-8 text-brand-trophy-gold mb-3" />
              <h3 className="text-lg font-semibold mb-2">Service Area</h3>
              <p className="text-sm text-gray-300">Eastern North Carolina</p>
              <p className="text-xs text-gray-400">Rocky Mount & surrounding areas</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoofMaterialsCTA;
